import React, { useEffect, useState } from "react";
import Button from "../../../components/button";

// redux
import { mapDispatchProps, mapStateToProps } from "../../../store/store";
import { connect } from "react-redux";
import TextInputField from "../../../components/textInput";
import Select from "../../../components/select";
import Checkbox from "../../../components/checkbox";
import API from "../../../api";
import { RefreshCw, Trash, PlusSquare } from "react-feather";
import Swal from "sweetalert2";
import { ChromePicker } from "react-color";
import Util from "./util";
import { useLanguage } from '@languages/index';



interface Props {
  initSearchTxt?: string;
  onSelect?: any;
  searchProducts?: boolean;
  searchBsProducts?: boolean;

  auth?: any;
  showModal?: any;
  closeModal?: any;
}

const ProductSelector = (props: Props) => {
  const language = useLanguage();   
  const languageTexts = { ...language.common, ...language.pages.sns };

  const [searchedProducts, setSearchedPoducts] = useState([]);
  const [searchTxt       , setSearchTxt      ] = useState(props.initSearchTxt);
  const [searchTimer     , setSearchTimer    ] = useState(null);


  const _searchDelayed = (value) => {
    if (searchTimer != null)
      clearTimeout(searchTimer);

    setSearchTimer(
        setTimeout(
          async () => {
            const txt = value.trim();

            let products = [];
            if (txt.length > 0) {
              try {
                if (props.searchBsProducts) {
                  const bsprodRes = await API.BrandSns.searchBsProductsByName({
                    brandToken: props.auth.token,
                    name: txt,
                  });
                  products = products.concat(bsprodRes.data.bsProducts.map((e)=>({
                      ...e,
                      thumbnailSmUrl: Util.makeImageUrl('brand_sns', e.imageUrl),
                      isBsProduct: true
                  })));
                }

                if (props.searchProducts) {
                  const productRes = await API.Product.index({
                    brandToken: props.auth.token,
                    type: "PRODUCT",
                    product_name: txt,
                    size: 800,
                  });
                  products = products.concat(productRes.data.products);
                }

              }catch (e) {
                console.log(e);
                products = [];
              }
            }

            setSearchedPoducts(products);
          },
          1000
        )
    );
  };


  useEffect(() => {
    if (searchTxt.trim().length > 0)
      _searchDelayed(searchTxt)
  }, []);


  return (
    <div className="flex flex-col">
      <div className="modal-window bg-white mb-10">
        <div className="modal-body w-[335px]">
          <div className="flex flex-col w-full">

            {/*search bar*/}
            <div className="flex flex-row items-center w-full pr-[20px]">
              <img className="m-[20px]" src="/assets/icons/search.svg" />
              <TextInputField
                className="grow"
                value={searchTxt}
                placeholder={languageTexts.product_text_1}
                onChangeText={(value) => {
                  setSearchTxt(value);

                  _searchDelayed(value);
                }}
              />
            </div>


            <div className="p-[20px] flex flex-col w-full">
              {/*product list*/}
              <div className="h-[361px] flex flex-col items-center overflow-y-scroll scrollbar">
                {
                  searchedProducts.map(
                      (prd) => [
                        (
                          <div
                            key={prd.id}
                            className="w-full flex flex-row justify-items-start items-center cursor-pointer"
                            onClick={(e) => {
                              props.onSelect(prd);
                              props.closeModal();
                            }}
                          >
                            <img
                              className="object-contain w-[72px] h-[72px] bg-[#D9D9D9]"
                              src={prd.thumbnailSmUrl}
                            />
                            <div className="flex flex-col gap-1 grow overflow-hidden px-5">
                              <span className="font-medium text-[15px] whitespace-nowrap overflow-hidden overflow-ellipsis">
                                {prd.name}
                              </span>

                              <span
                                className="text-black text-[15px] font-normal"
                                style={{ wordBreak: "keep-all" }}
                              >
                                {languageTexts._wear(prd.sizeName)}
                              </span>

                              <div className="flex flex-row gap-5 justify-between">
                                <span
                                  className="text-[15px] text-[#0066FF] whitespace-nowrap truncate text-ellipsis overflow-hidden max-w-[350px]"
                                >
                                  {`${_getUrlText(prd.url)}`}
                                </span>
                              </div>
                            </div>
                          </div>
                        ),
                        (
                          <div key={prd.id + '_sep'} className="my-[10px] w-full h-[1px] bg-[#F4F4F4]">&nbsp;</div>
                        )
                      ]
                  )
                }
              </div>

              {/*cancel button*/}
              <Button
                bordered
                borderColor="#E8E8E8"
                text={languageTexts.cancel}
                onClick={() => {
                  props.closeModal();
                }}
              />
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchProps)(ProductSelector);




const _getUrlText = (url: string) => {
if (!url) return "";

if (url.startsWith("http")) {
  return url;
} else {
  return `https://${url}`;
}
};
